// Copyright ©️ 2026 eVolve MEP, LLC

import { useEvolvePaginatedGet, type Facility } from '@evolvemep/api-ts';

import { SearchableList } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableList';

type PartialFacility = Pick<Facility, 'facilityName' | 'facilityId'>;

type Props = {
  value?: PartialFacility | null;
  onChange: (value: PartialFacility | null) => void;
};

export const FacilityListSelector = ({ value, onChange }: Props) => {
  const paginatedGet = useEvolvePaginatedGet('shop/facility');
  return (
    <SearchableList
      paginatedGet={paginatedGet}
      value={value}
      onChange={onChange}
      getItemLabel={(f) => f.facilityName}
      idKey="facilityId"
    />
  );
};
